import { render, staticRenderFns } from "./SportSubscriptionRequirements.vue?vue&type=template&id=3a9772ea"
import script from "./SportSubscriptionRequirements.vue?vue&type=script&lang=js"
export * from "./SportSubscriptionRequirements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports